import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aero_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Main business phone number.
export const BUSINESS = {
  name: "AeroAcres Drone Spraying",
  phone: "786-384-5030",
  phoneRaw: "+17863845030",
  email: "contact@aeroacres.online",
  address: "24850 SW 197th Ave, Homestead, FL 33031",
  area: "Homestead • Miami-Dade • South Florida",
  hours: "Mon–Sat · 6:00am – 7:00pm",
};

// Brand assets - self-hosted from /app/frontend/public/
export const LOGO_URL = "/logo.png";

// Public site origin used for SEO landing pages (canonical + JSON-LD).
export const SITE_URL = "https://aeroacres.online";
